module.exports = __webpack_public_path__ + "static/mauro-0f287a6f782a4511792086f88f7567ad.png";